import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { castDraft, immerable, produce } from 'immer';
import { Map } from 'immutable';

import { MemberItemEntity } from './member-item.entity';

export interface IMemberListExtra extends IListColumnConfig<MemberItemEntity> {
	width?: string | number;
}

interface IMemberList extends IListAttrs<MemberItemEntity> {
	availableColumns: Map<string, IMemberListExtra>;
	totalItemsCount: number;
}

const entityDefaults: IMemberList = {
	elements: Map(),
	availableColumns: Map(),
	totalItemsCount: 0,
};

export class MemberListEntity
	implements IMemberList, IListOperations<MemberListEntity, MemberItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;
	public totalItemsCount = entityDefaults.totalItemsCount;

	public static build(
		availableCols: Array<IMemberListExtra>
	): MemberListEntity {
		const inst = new MemberListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IMemberListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	public constructor(params: Partial<IMemberList> = {}) {
		this.availableColumns =
			params.availableColumns ?? entityDefaults.availableColumns;
		this.elements = params.elements ?? entityDefaults.elements;
		this.totalItemsCount =
			params.totalItemsCount ?? entityDefaults.totalItemsCount;

		return this;
	}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<MemberItemEntity>
	> {
		return this.availableColumns;
	}
	public setElements(elems: Map<string, MemberItemEntity>): MemberListEntity {
		return produce(this, (draft) => {
			draft.elements = castDraft(elems);
		});
	}

	public setTotalItemsCount(val: number): MemberListEntity {
		return produce(this, (draft) => {
			draft.totalItemsCount = castDraft(val);
		});
	}

	public setMemberListData(
		elems: Map<string, MemberItemEntity>,
		total: number
	): MemberListEntity {
		return produce(this, (draft) => {
			draft.elements = castDraft(elems);
			draft.totalItemsCount = castDraft(total);
		});
	}
}
